import {LandingNames} from "../components/landings";

export const SESSION_DURATION_MINUTES = 5;
export const WF_ENDPOINT = import.meta.env.VITE_WF_ENDPOINT;
export const WSS_ENDPOINT = import.meta.env.VITE_WSS_ENDPOINT;
export const CHG_ENDPOINT = import.meta.env.VITE_CHG_ENDPOINT;
export const BASIC_AUTH = import.meta.env.VITE_BASIC_AUTH;
export const LANDING: LandingNames = import.meta.env.VITE_LANDING as LandingNames;

export const VERSION = import.meta.env.VITE_VERSION;

export const AUTH0_DOMAIN = "auth.kopjra.com";
export const AUTH0_CLIENT_ID = "Vcv7tYFBkTFWQlaHCcUYG3U1YPZPfyte";
export const AUTH0_AUDIENCE = "https://api.gateway.kopjra.com";

export const APP_LOCAL_STORAGE = window.location.origin;
